// assets
import { IconBrandChrome, IconHelp } from '@tabler/icons';

// constant
const icons = { IconBrandChrome, IconHelp };

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

export const settings = {
    id: 'settings',
    title: 'Settings',
    type: 'group',
    children: [
        {
            id: 'Platform-settings',
            title: 'Platform Settings',
            type: 'item',
            url: '/admin/settings',
            icon: icons.IconBrandChrome,
            breadcrumbs: false
        },

        {
            id: 'profile',
            title: 'Profile',
            type: 'item',
            url: '/admin/profile',
            icon: icons.IconHelp
            // target: true
        }
    ]
};

export const vendorSettings = {
    id: 'settings',
    title: 'Settings',
    type: 'group',
    children: [
        {
            id: 'account-settings',
            title: 'Account Settings',
            type: 'item',
            url: '/vendor/settings',
            icon: icons.IconBrandChrome,
            breadcrumbs: false
        },
        {
            id: 'profile',
            title: 'Profile',
            type: 'item',
            url: '/vendor/profile',
            icon: icons.IconHelp,
            breadcrumbs: false
        }
    ]
};
